import React from 'react';
import ShopLayout from '@views/components/shop/ShopLayout';
import Sidebar from '@views/modules/account-sidebar';
import { useRouter } from 'next/router';
import useLayoutContext from '@views/layouts/hooks/use-context';

export const MasterLayout = ({ children }) => {
  const router = useRouter();
  const { loading, error, authenticated } = useLayoutContext();

  if (loading || error) {
    return <div />;
  }

  if (!authenticated) {
    router.push('/');

    return null;
  }

  return (
    <ShopLayout>
      <ShopLayout.Sidebar as="nav" className="d-none d-lg-block">
        <Sidebar />
      </ShopLayout.Sidebar>
      <ShopLayout.Content>{children}</ShopLayout.Content>
    </ShopLayout>
  );
};

export default MasterLayout;
